import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2D387C",
        secondary: "#6FACDE",
        accent: "#A4C8E1",
        error: "#b71c1c",
        // checkbox: "#FFFFFF",
      },
    },
  },
});
